import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { Typography } from '../Typography';
export function PageLoader(props) {
    return (_jsxs(PageLoaderRootStyled, { children: [_jsx(PageLoaderStyled, {}), !!props.loadingText && (_jsx(Typography, { variant: "h4", component: "div", children: props.loadingText }))] }));
}
const PageLoaderRootStyled = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
}));
const PageLoaderStyled = styled('div')(({ theme }) => ({
    '@keyframes pageLoaderAnimation': {
        from: {
            transform: 'rotate(0deg)',
        },
        to: {
            transform: 'rotate(360deg)',
        },
    },
    display: 'inline-block',
    width: '80px',
    height: '80px',
    '&:after': {
        content: '""',
        display: 'block',
        width: '64px',
        height: '64px',
        margin: '8px',
        borderRadius: '50%',
        border: `6px solid ${theme.palette.primary.light}`,
        borderColor: `${theme.palette.primary.light} transparent ${theme.palette.primary.dark} transparent`,
        animation: 'pageLoaderAnimation 1.2s linear infinite',
    },
}));
